'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dType$0024 from "./mealorama.-Meal-Type$.js";
import * as $j_mealorama$002eschedule$0024package$0024$002dScheduled$002dMeal$002dId$0024 from "./mealorama.schedule$package$-Scheduled-Meal-Id$.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScheduledMeal(id_$_lo, id_$_hi, accountId_$_lo, accountId_$_hi, date, mealType, courses, googleEventId, deleted) {
  this.gF = 0;
  this.gG = 0;
  this.mU = 0;
  this.mV = 0;
  this.bE = null;
  this.dL = null;
  this.e0 = null;
  this.kJ = null;
  this.kI = false;
  this.sM = false;
  this.gF = id_$_lo;
  this.gG = id_$_hi;
  this.mU = accountId_$_lo;
  this.mV = accountId_$_hi;
  this.bE = date;
  this.dL = mealType;
  this.e0 = courses;
  this.kJ = googleEventId;
  this.kI = deleted;
  this.sM = ($j_mealorama$002eschedule$0024package$0024$002dScheduled$002dMeal$002dId$0024.$m_Lmealorama_schedule$package$ScheduledMealId$(), ((id_$_hi === 0) ? (id_$_lo !== 0) : (id_$_hi > 0)));
}
export { $c_Lmealorama_ScheduledMeal as $c_Lmealorama_ScheduledMeal };
$p = $c_Lmealorama_ScheduledMeal.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScheduledMeal;
/** @constructor */
function $h_Lmealorama_ScheduledMeal() {
}
export { $h_Lmealorama_ScheduledMeal as $h_Lmealorama_ScheduledMeal };
$h_Lmealorama_ScheduledMeal.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-1814734352));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.gF, this.gG)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.mU, this.mV)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.bE));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.dL));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.e0));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kJ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.kI ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 7);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_ScheduledMeal)) {
    if ((this.kI === x$0.kI)) {
      var x_$_lo = this.gF;
      var x_$_hi = this.gG;
      var $x_6 = x$0;
      var x$1_$_lo = $x_6.gF;
      var x$1_$_hi = $x_6.gG;
      var $x_5 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$2_$_lo = this.mU;
      var x$2_$_hi = this.mV;
      var $x_7 = x$0;
      var x$3_$_lo = $x_7.mU;
      var x$3_$_hi = $x_7.mV;
      var $x_4 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$4 = this.bE;
      var x$2$1 = x$0.bE;
      var $x_3 = ((x$4 === null) ? (x$2$1 === null) : x$4.f(x$2$1));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3$1 = this.dL;
      var x$4$1 = x$0.dL;
      var $x_2 = ((x$3$1 === null) ? (x$4$1 === null) : (x$3$1 === x$4$1));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.e0;
      var x$6 = x$0.e0;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.kJ;
      var x$8 = x$0.kJ;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 7;
});
$p.r = (function() {
  return "ScheduledMeal";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.gF, this.gG);
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.mU, this.mV);
      break;
    }
    case 2: {
      return this.bE;
      break;
    }
    case 3: {
      return this.dL;
      break;
    }
    case 4: {
      return this.e0;
      break;
    }
    case 5: {
      return this.kJ;
      break;
    }
    case 6: {
      return this.kI;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.b2R = (function() {
  var x18 = this.dL;
  var x = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__breakfast__Lmealorama_MealType();
  if (((x === null) ? (x18 === null) : (x === x18))) {
    return "Breakfast";
  }
  var x$3 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__lunch__Lmealorama_MealType();
  if (((x$3 === null) ? (x18 === null) : (x$3 === x18))) {
    return "Lunch";
  }
  var x$5 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__dinner__Lmealorama_MealType();
  if (((x$5 === null) ? (x18 === null) : (x$5 === x18))) {
    return "Dinner";
  }
  var x$7 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__snack__Lmealorama_MealType();
  if (((x$7 === null) ? (x18 === null) : (x$7 === x18))) {
    return "Snack";
  }
  var x$9 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__other__Lmealorama_MealType();
  if (((x$9 === null) ? (x18 === null) : (x$9 === x18))) {
    return "Other";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x18);
});
$p.OW = (function(prefs) {
  var x19 = this.dL;
  var x = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__breakfast__Lmealorama_MealType();
  if (((x === null) ? (x19 === null) : (x === x19))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDateTime$().sl(this.bE, prefs.m6);
  }
  var x$3 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__lunch__Lmealorama_MealType();
  if (((x$3 === null) ? (x19 === null) : (x$3 === x19))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDateTime$().sl(this.bE, prefs.mb);
  }
  var x$5 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__dinner__Lmealorama_MealType();
  if (((x$5 === null) ? (x19 === null) : (x$5 === x19))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDateTime$().sl(this.bE, prefs.m9);
  }
  var x$7 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__snack__Lmealorama_MealType();
  if (((x$7 === null) ? (x19 === null) : (x$7 === x19))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDateTime$().sl(this.bE, prefs.mf);
  }
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Ljava_time_LocalDateTime$().sl(this.bE, prefs.md);
});
$p.aQN = (function(prefs) {
  var x20 = this.dL;
  var x = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__breakfast__Lmealorama_MealType();
  if (((x === null) ? (x20 === null) : (x === x20))) {
    var this$1 = this.OW(prefs);
    return prefs.m7.HF(this$1);
  }
  var x$3 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__lunch__Lmealorama_MealType();
  if (((x$3 === null) ? (x20 === null) : (x$3 === x20))) {
    var this$2 = this.OW(prefs);
    return prefs.ma.HF(this$2);
  }
  var x$5 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__dinner__Lmealorama_MealType();
  if (((x$5 === null) ? (x20 === null) : (x$5 === x20))) {
    var this$3 = this.OW(prefs);
    return prefs.m8.HF(this$3);
  }
  var x$7 = $j_mealorama$002e$002dMeal$002dType$0024.$s_Lmealorama_MealType$__snack__Lmealorama_MealType();
  if (((x$7 === null) ? (x20 === null) : (x$7 === x20))) {
    var this$4 = this.OW(prefs);
    return prefs.me.HF(this$4);
  }
  var this$5 = this.OW(prefs);
  return prefs.mc.HF(this$5);
});
$p.xY = (function() {
  var this$1 = this.e0;
  var these = this$1;
  while ((!these.b())) {
    var x0 = these.e();
    var this$2 = x0.ij;
    matchResult1: {
      var $x_1;
      if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        var b = this$2.b8;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$();
        var $x_1 = (b !== "");
        break matchResult1;
      }
      if ((this$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        var $x_1 = true;
        break matchResult1;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$2);
    }
    if ($x_1) {
      return true;
    }
    these = these.c();
  }
  return false;
});
function $isArrayOf_Lmealorama_ScheduledMeal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jS)));
}
export { $isArrayOf_Lmealorama_ScheduledMeal as $isArrayOf_Lmealorama_ScheduledMeal };
var $d_Lmealorama_ScheduledMeal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScheduledMeal, "mealorama.ScheduledMeal", ({
  jS: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_ScheduledMeal as $d_Lmealorama_ScheduledMeal };
//# sourceMappingURL=mealorama.-Scheduled-Meal.js.map
